const easeInOut = (p) =>
  p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;

const easeOut = (p) => 1 - Math.pow(1 - p, 3);

// ---------------- PAN ----------------
export const animPanLeft = (p, canvas) => {
  p = easeInOut(p);
  return { scale: 1, offsetX: -p * canvas.width * 0.15, offsetY: 0 };
};

export const animPanRight = (p, canvas) => {
  p = easeInOut(p);
  return { scale: 1, offsetX: p * canvas.width * 0.15, offsetY: 0 };
};

export const animPanUp = (p, canvas) => {
  p = easeInOut(p);
  return { scale: 1, offsetX: 0, offsetY: -p * canvas.height * 0.15 };
};

export const animPanDown = (p, canvas) => {
  p = easeInOut(p);
  return { scale: 1, offsetX: 0, offsetY: p * canvas.height * 0.15 };
};

// ---------------- KEN BURNS ----------------
export const animKenBurns = (p, canvas) => {
  p = easeInOut(p);
  return {
    scale: 1 + p * 0.15,
    offsetX: (p - 0.5) * canvas.width * 0.1,
    offsetY: (p - 0.5) * canvas.height * 0.05,
  };
};

// ---------------- SHAKE ----------------
export const animCameraShake = (p) => {
  const strength = 4 * Math.sin(p * Math.PI * 6);
  return {
    scale: 1,
    offsetX: (Math.random() - 0.5) * strength,
    offsetY: (Math.random() - 0.5) * strength,
  };
};

// ---------------- TILT ----------------
export const animTilt = (p) => {
  p = easeInOut(p);
  return {
    scale: 1,
    offsetX: (p - 0.5) * 40,
    offsetY: 0,
  };
};

// ---------------- BOUNCE ----------------
export const animBounce = (p) => ({
  scale: 1,
  offsetX: 0,
  offsetY: -Math.sin(p * Math.PI) * 18,
});

// ---------------- ZOOM POP ----------------
export const animZoomPop = (p) => {
  p = easeOut(p);
  const pop = p < 0.4 ? p * 2.5 : 1 - (p - 0.4) * 0.3;
  return {
    scale: 1 + pop * 0.25,
    offsetX: 0,
    offsetY: 0,
  };
};

// ---------------- REGISTRY ----------------
export const ANIMATION_DELTAS = {
  "pan-left": animPanLeft,
  "pan-right": animPanRight,
  "pan-up": animPanUp,
  "pan-down": animPanDown,
  "ken-burns": animKenBurns,
  "camera-shake": animCameraShake,
  "tilt": animTilt,
  "bounce": animBounce,
  "zoom-pop": animZoomPop,
};
